import { Typography } from '@mui/material';
import * as React from 'react';
import jsonStyles from '../../StylesCarnet.json';

const TextCarnetComponent = ({
  carnetStore,
  updatePosition,
  notEdit,
  name,
  value,
}) => {
  function getStyles(id) {
    return carnetStore.activo?.[id] ?? jsonStyles[id];
  }

  const [position, setPosition] = React.useState();
  const isActivo = carnetStore.stylesCarnet?.id === name;

  return (
    // <Draggable
    //   key={name}
    //   disabled={true}
    //   // disabled={notEdit}
    //   bounds="parent"
    //   defaultPosition={{
    //     x: getStyles(name).x,
    //     y: getStyles(name).y,
    //   }}
    //   grid={[1, 1]}
    //   onDrag={(e, data) => {
    //     let x = getStyles(name).x + parseInt(data.x);
    //     let y = getStyles(name).y + parseInt(data.y);

    //     if (x < 0) x = 0;
    //     if (y < 0) y = 0;

    //     const layoutSize = getSizeLayoutCarnet();

    //     if (x > layoutSize.wx) x = layoutSize.wx;
    //     if (y > layoutSize.hx) y = layoutSize.hx;

    //     setPosition({
    //       x: parseInt((x * 100) / layoutSize.wx),
    //       y: parseInt((y * 100) / layoutSize.hx),
    //     });

    //     // y: parseInt((y * getSizeLayoutCarnet().hx) / 100),
    //     // updatePosition(name, data.x, data.y);
    //   }}
    // >
    //   <Box
    //     sx={{
    //       position: 'absolute',
    //       border: isActivo ? 'solid blue 1.5px' : null,
    //       cursor: 'pointer',
    //       '&:hover': notEdit
    //         ? null
    //         : {
    //             border: 'solid blue 1.5px',
    //           },
    //       display: getStyles(name).display,
    //       width:
    //         getStyles(name).width === 0 ? null : `${getStyles(name).width}%`,
    //       height:
    //         getStyles(name).height === 0 ? null : `${getStyles(name).height}%`,
    //       left: `${getStyles(name).x}%`,
    //       top: `${getStyles(name).y}%`,
    //       backgroundColor: getStyles(name).backgroundColor,
    //       borderRadius: `${getStyles(name).borderRadius}px`,
    //       ...(!isActivo && {
    //         borderWidth: `${getStyles(name).borderWidth}px`,
    //       }),
    //     }}
    //   >
    //     {position && (
    //       <Box sx={{ width: '50px', fontWeight: 'bold', fontSize: '8pt' }}>
    //         {position?.x}, {position?.y}
    //       </Box>
    //     )}
    //     <Typography
    //       textAlign="center"
    //       // onClick={() => _onClickComponent(entidad)}
    //       sx={{
    //         fontSize: `${getStyles(name).fontSize}pt`,
    //         color: getStyles(name).fontColor,
    //         fontFamily: getStyles(name).fontFamily,
    //         fontWeight: getStyles(name).fontWeight,
    //         textAlign: getStyles(name).textAlign,
    //         verticalAlign: getStyles(name).textBaseline,
    //         textShadow: `${getStyles(name).textShadowX}px ${
    //           getStyles(name).textShadowY
    //         }px ${getStyles(name).textShadowBlur}px ${
    //           getStyles(name).textShadowColor
    //         }`,
    //         lineHeight: `${
    //           getStyles(name).lineHeight === 0
    //             ? null
    //             : getStyles(name).lineHeight
    //         }em`,
    //       }}
    //     >
    //       {value}
    //     </Typography>
    //   </Box>
    // </Draggable>

    <Typography
      textAlign="center"
      // onClick={() => _onClickComponent(entidad)}
      sx={{
        position: 'absolute',
        border: isActivo && !notEdit ? 'solid blue 1.5px' : null,
        cursor: 'pointer',
        '&:hover': notEdit
          ? null
          : {
              border: 'solid blue 1.5px',
            },
        display: getStyles(name).display,
        width: getStyles(name).width === 0 ? null : `${getStyles(name).width}%`,
        height:
          getStyles(name).height === 0 ? null : `${getStyles(name).height}%`,
        left: `${getStyles(name).x}%`,
        top: `${getStyles(name).y}%`,
        backgroundColor: getStyles(name).backgroundColor,
        borderRadius: `${getStyles(name).borderRadius}px`,
        ...(!isActivo && {
          borderWidth: `${getStyles(name).borderWidth}px`,
        }),
        fontSize: `${getStyles(name).fontSize}pt`,
        color: getStyles(name).fontColor,
        fontFamily: getStyles(name).fontFamily,
        fontWeight: getStyles(name).fontWeight,
        fontStyle: getStyles(name).fontStyle,
        textAlign: getStyles(name).textAlign,
        verticalAlign: getStyles(name).textBaseline,
        textShadow: `${getStyles(name).textShadowX}px ${
          getStyles(name).textShadowY
        }px ${getStyles(name).textShadowBlur}px ${
          getStyles(name).textShadowColor
        }`,
        lineHeight: `${
          getStyles(name).lineHeight === 0 ? null : getStyles(name).lineHeight
        }em`,
        whiteSpace: 'pre-wrap',
      }}
    >
      {value}
    </Typography>
  );
};

export default TextCarnetComponent;
